module.exports = __webpack_public_path__ + "img/home1.61ec78a3.jpg";